/**
 * Retained list of files that failed in the last ASN document batch (CR-7163 (b)).
 *
 * Toasts alone are not enough for a multi-file upload: in a 20-file batch they
 * scroll away and the user cannot tell which pieces of paperwork are missing.
 */
import { X } from 'lucide-react';
import type { FailedUpload } from './useASNDocumentUpload';

interface ASNUploadFailuresProps {
  failed: FailedUpload[];
  onDismiss: () => void;
}

export function ASNUploadFailures({ failed, onDismiss }: ASNUploadFailuresProps) {
  if (failed.length === 0) return null;
  return (
    <div className="mt-3 rounded-lg border border-red-200 bg-red-50 p-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium text-red-800">
          {failed.length === 1
            ? '1 file did not upload'
            : `${failed.length} files did not upload`}
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="p-0.5 rounded hover:bg-red-100 text-red-700"
          title="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
      <ul className="mt-1.5 space-y-0.5">
        {failed.map((f, i) => (
          <li key={`${f.name}-${i}`} className="text-xs text-red-700">
            <span className="font-medium">{f.name}</span> — {f.reason}
          </li>
        ))}
      </ul>
    </div>
  );
}
